@if (showProgressTracker$()) {
  @if (workflowSections$(); as workflowSections) {
    <section class="progress-tracker">
      @for (section of workflowSections; track $index) {
        @switch (section.step.status) {
          @case (status.inProgress) {
            <div class="step in-progress-border">
              <span class="in-progress-item">
                <svg-icon name="in-progress"></svg-icon>
                {{ section.step.name | titlecase }}
              </span>
            </div>
            <div class="children">
              @for (childSection of section.children; track $index) {
                <div class="step">
                  @switch (childSection.status) {
                    @case (status.inProgress) {
                      <span class="in-progress-item">
                        <svg-icon name="in-progress"></svg-icon>
                        {{ childSection.name | titlecase }}
                      </span>
                    }
                    @case (status.complete) {
                      <span class="completed-item">
                        <svg-icon name="completed"></svg-icon>
                        {{ childSection.name | titlecase }}
                      </span>
                    }
                    @case (status.notStarted) {
                      <span class="not-started-item">
                        <svg-icon name="not-started"></svg-icon>
                        {{ childSection.name | titlecase }}
                      </span>
                    }
                  }
                </div>
              }
            </div>
          }
          @case (status.notStarted) {
            <div class="step">
              <span class="not-started-item">
                <svg-icon name="not-started"></svg-icon>
                {{ section.step.name | titlecase }}
              </span>
            </div>
          }
          @case (status.complete) {
            <div class="step">
              <span class="completed-item">
                <svg-icon name="completed"></svg-icon>
                {{ section.step.name | titlecase }}
              </span>
            </div>
          }
        }
      }
    </section>
  }
}
